import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '1012782631449952';
declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
    _fbq?: unknown;
  }
}
/**
 * Loads the Meta (Facebook) Pixel and fires a PageView event on mount.
 * Rendered once at the app root.
 */
export function MetaPixel() {
  useEffect(() => {
    if (window.fbq) {
      // Already initialized (e.g. hot reload) — just track the view.
      window.fbq('track', 'PageView');
      return;
    }
    /* eslint-disable */
    ;
    (function (f: any, b: Document, v: string) {
      if (f.fbq) return;
      const n: any = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = b.createElement('script') as HTMLScriptElement;
      t.async = true;
      t.src = v;
      // Append directly to <head> (fall back to <body>/<html>) instead of
      // relying on an existing <script> tag, which may not exist in a
      // bundled/iframe app and caused a "reading 'parentNode'" crash.
      const parent = b.head || b.body || b.documentElement;
      parent.appendChild(t);
    })(window, document, 'https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
    window.fbq?.('init', PIXEL_ID);
    window.fbq?.('track', 'PageView');
  }, []);
  return <noscript data-id="element-125">
      <img height="1" width="1" style={{
      display: 'none'
    }} alt="" src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-126" />
    </noscript>;
}